module.exports = __webpack_public_path__ + "static/media/book_sample3.ec762faf.png";